import { render, staticRenderFns } from "./ConsolidatedUsageList.vue?vue&type=template&id=b85bec6c&scoped=true&"
import script from "./ConsolidatedUsageList.vue?vue&type=script&lang=js&"
export * from "./ConsolidatedUsageList.vue?vue&type=script&lang=js&"
import style0 from "./ConsolidatedUsageList.vue?vue&type=style&index=0&id=b85bec6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85bec6c",
  null
  
)

export default component.exports